import "babel-polyfill";
import "APP_ASSETS/styles.scss";
import React from "react";
import { Switch, Route } from "react-router";
import ReduxToastr from "react-redux-toastr";
import InfoLogo from "APP_ROOT/InfoLogo";
import { Login } from "MODULES/session/components";
import ForgotPassword from "MODULES/session/components/ForgotPassword/ForgotPassword";
import ResetPassword from "MODULES/session/components/ResetPassword/ResetPassword";
import IncomingQuote from "MODULES/Customers/IncomingQuote/IncomingQuote";
import QbRedirect from "MODULES/Admin/Integrations/QbRedirect";
import Layout from "./Layout";

export default function App() {
  return (
    <div className="app">
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password" component={ResetPassword} />
        <Route path="/customer-iq" component={IncomingQuote} />
        <Route exact path="/integrations/redirect" component={QbRedirect} />
        <Route path="/" component={Layout} />
      </Switch>
      <ReduxToastr
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        preventDuplicates
        position="bottom-right"
      />
      <InfoLogo />
      <div id="modal-root" style={{ position: "absolute", top: 0 }} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/App.jsx